import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { AppointmentSchedulingConfiguration } from '../../config/appointment_scheduling_configuration';
import { AppointmentsAvailableTimesQuery } from '../../queries/appointments_available_times_query';
import { AppointmentsLocationsQuery } from '../../queries/appointments_locations_query';
import { AppointmentButtonServant } from '../../servants/appointment_button_servant';
import { AppointmentsAvailableTimesServant } from '../../servants/appointments_available_times_servant';
import { IAppointmentsTabsConfiguration } from '../../servants/appointments_tabs_configuration';
import { AppointmentUsersourceServant } from '../../servants/appointments_usersource_servant';
import MyAppointmentsStateService from '../../services/my_appointment_state_service';
import { IAvailableTime } from '../../types/appointment_interfaces';
import { TAppointmentAvailableTimesUsersource } from '../../usersources/appointment_available_times_usersource';
import { TAppointmentLocationsOrganizersUsersource } from '../../usersources/appointment_location_staff_usersource';
import { TAppointmentReasonUsersource } from '../../usersources/appointment_reason_usersource';

interface ISelectedDateTime {
  am: boolean;
  date: string;
  day: string;
  day_week: number;
  selected: boolean;
  time: string;
}

export class AvailableTimesController {
  private isGroupAppointment: boolean = false;
  private isLoading: boolean = true;
  private initialLoading: boolean = true;
  private selectedTime: string = '';
  private hasSelectedTime: boolean = false;

  constructor(
    private $stateParams: any,
    public ngAppointmentsAvailableTimesQuery: AppointmentsAvailableTimesQuery,
    private QueryMediator: IQueryMediator,
    private ngAppointmentsTabsConfiguration: IAppointmentsTabsConfiguration,
    private loadAppointmentsAvailableTimesCommand: ICommand,
    private AppointmentsTimeSelectionChangeCommand: ICommand,
    private ngAppointmentAvailableTimesUsersource: TAppointmentAvailableTimesUsersource,
    private ngAppointmentsLocationsQuery: AppointmentsLocationsQuery,
    private ngAppointmentReasonUsersource: TAppointmentReasonUsersource,
    private ngAppointmentLocationsOrganizersUsersource: TAppointmentLocationsOrganizersUsersource,
    private ngAppointmentsAvailableTimesServant: AppointmentsAvailableTimesServant,
    private ngAppointmentUsersourceServant: AppointmentUsersourceServant,
    private ngMyAppointmentsStateService: MyAppointmentsStateService,
    private ngAppointmentSchedulingConfiguration: AppointmentSchedulingConfiguration,
    private ngAppointmentButtonServant: AppointmentButtonServant
  ) {}

  $onInit() {
    const userServant = this.ngAppointmentUsersourceServant;
    if (!userServant.canUserRequest && !userServant.canUserSchedule && userServant.canUserViewWalkins) {
      this.ngMyAppointmentsStateService.skipAndGo(this.ngMyAppointmentsStateService.states.walkIn, {}, true);
    } else if (!userServant.canUserSchedule) {
      this.ngMyAppointmentsStateService.skipAndGo(this.ngMyAppointmentsStateService.states.alternateTimes, {}, true);
    } else if (_4.isEmpty(this.ngAppointmentAvailableTimesUsersource.read().selectedTime)) {
      this.isLoading = true;
      this.loadAppointmentsAvailableTimesCommand(0, this.$stateParams.invitationId).then(() => {
        this.isLoading = false;
        this.initialLoading = false;
        this.ngMyAppointmentsStateService.stateLoaded();
      });
    } else {
      this.isLoading = false;
      this.initialLoading = false;
      this.ngMyAppointmentsStateService.stateLoaded();
    }
    this.ngAppointmentButtonServant.setDefaults();
    this.hasSelectedTime = !_4.isEmpty(this.ngAppointmentAvailableTimesUsersource.read().selectedTime);
    if (this.hasSelectedTime) {
      this.selectedTime = moment(
        this.ngAppointmentAvailableTimesUsersource.read().selectedTimeDetails.begin_time
      ).format('MMM D @ h:mm A');
      this.isGroupAppointment =
        this.ngAppointmentAvailableTimesUsersource.read().selectedTimeDetails.dropin_allowed > 1;
    }
  }

  timeSelectionChanged(item: ISelectedDateTime): void {
    if (!_4.isEmpty(item)) {
      this.selectedTime = moment(item.date).format('MMM D @ h:mm A');
      this.hasSelectedTime = !_4.isEmpty(this.selectedTime);
      const flattenAvailableTimes = this.ngAppointmentsAvailableTimesQuery.result.flattenAvailableTimes;
      this.ngAppointmentAvailableTimesUsersource.set('selectedTime', item as any as IAvailableTime);
      const unixtime: string = _4.toString(moment(item.date, 'YYYY-MM-DD hh:mm A').unix());
      this.ngAppointmentAvailableTimesUsersource.set(
        'selectedTimeDetails',
        _4.find(flattenAvailableTimes, (time: any) => _4.head(_4.split(time.range, '_')) === unixtime)
      );
      this.isGroupAppointment =
        this.ngAppointmentAvailableTimesUsersource.read().selectedTimeDetails.dropin_allowed > 1;
      this.ngAppointmentsTabsConfiguration.stepCompleted('3');
    } else {
      this.ngAppointmentAvailableTimesUsersource.set('selectedTimeDetails', {} as IAvailableTime);
      this.ngAppointmentsTabsConfiguration.stepInComplete('3');
    }
    this.ngAppointmentButtonServant.setDefaults();
  }

  resolveOk() {
    return new Promise(() => {
      return [];
    });
  }
  getNextweekTimes() {
    if (this.isLoading) {
      return this.resolveOk();
    }
    this.isGroupAppointment = false;
    this.isLoading = true;
    return this.loadAppointmentsAvailableTimesCommand(
      this.ngAppointmentsAvailableTimesServant.nextWeekOffset,
      this.$stateParams.invitationId
    ).then(() => {
      this.isLoading = false;
      return this.ngAppointmentsAvailableTimesQuery.result.availableTimesList;
    });
  }
  getPreviousweekTimes() {
    if (this.isLoading) {
      return this.resolveOk();
    }
    this.isGroupAppointment = false;
    this.isLoading = true;
    return this.loadAppointmentsAvailableTimesCommand(
      this.ngAppointmentsAvailableTimesServant.previousWeekOffset,
      this.$stateParams.invitationId
    ).then(() => {
      this.isLoading = false;
      return this.ngAppointmentsAvailableTimesQuery.result.availableTimesList;
    });
  }
}

angular.module('capability-ng-appointments').controller('ngAvailableTimesController', AvailableTimesController);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/views/available_times/available_times.ts